import { render } from "./HeroiconsOutlineCake.vue?vue&type=template&id=f167775c"
const script = {}

import exportComponent from "/Users/flavianoviana/docker/business-sml/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCake.vue"]])

export default __exports__